import { __extends } from "tslib";
/* eslint-disable */
import React from "react";
import { TagInput } from "./TagInput";
import { FocusPosType } from "./TagSearchBox";
import { withTranslation } from "../i18n";
import { Bubble } from "../bubble";
import { Icon } from "../icon";
import { withConfig } from "../_util/config-context";
import { Text } from "../text";
var keys = {
    "8": "backspace",
    "13": "enter",
    "37": "left",
    "38": "up",
    "39": "right",
    "40": "down",
};
var ITag = /** @class */ (function (_super) {
    __extends(ITag, _super);
    function ITag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inEditing: false,
        };
        _this.handleTagClick = function (e, pos) {
            _this.props.dispatchTagEvent("click", pos);
            e.stopPropagation();
        };
        _this.handleDelete = function (e) {
            e.stopPropagation();
            _this.props.dispatchTagEvent("del");
        };
        _this.handleKeyDown = function (e) {
            if (!keys[e.keyCode])
                return;
            e.preventDefault();
            switch (keys[e.keyCode]) {
                case "tab":
                case "enter":
                    _this.props.dispatchTagEvent("click", "value");
                    break;
                case "backspace":
                    _this.props.dispatchTagEvent("del", "keyboard");
                    break;
            }
        };
        return _this;
    }
    ITag.prototype.focusTag = function () {
        var _a;
        (_a = this["input-inside"]) === null || _a === void 0 ? void 0 : _a.focusInput();
    };
    ITag.prototype.focusInput = function () {
        var _a;
        (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.focusInput();
    };
    ITag.prototype.resetInput = function () {
        var _a;
        (_a = this["input-inside"]) === null || _a === void 0 ? void 0 : _a.resetInput();
    };
    ITag.prototype.setInputValue = function (value, callback) {
        var _a;
        (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.setInputValue(value, callback);
    };
    ITag.prototype.getInputValue = function () {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.getInputValue();
    };
    ITag.prototype.addTagByInputValue = function () {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.addTagByInputValue();
    };
    ITag.prototype.addTagByEditInputValue = function () {
        var _a;
        if (!this["input-inside"])
            return;
        return (_a = this["input-inside"]) === null || _a === void 0 ? void 0 : _a.addTagByInputValue();
    };
    ITag.prototype.setInfo = function (info, callback) {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.setInfo(info, callback);
    };
    ITag.prototype.moveToEnd = function () {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.moveToEnd();
    };
    ITag.prototype.getInfo = function () {
        var _a = this.props, attr = _a.attr, values = _a.values;
        return { attr: attr, values: values };
    };
    ITag.prototype.edit = function (pos) {
        this.setState({ inEditing: true });
        var input = this["input-inside"];
        input === null || input === void 0 ? void 0 : input.setInfo(this.getInfo(), function () {
            if (pos === "attr") {
                return input.selectAttr();
            }
            return input.selectValue();
        });
    };
    ITag.prototype.editDone = function () {
        this.setState({ inEditing: false });
    };
    ITag.prototype.render = function () {
        var _this = this;
        var inEditing = this.state.inEditing;
        var _a = this.props, t = _a.t, classPrefix = _a.config.classPrefix, active = _a.active, attr = _a.attr, values = _a.values, dispatchTagEvent = _a.dispatchTagEvent, attributes = _a.attributes, focused = _a.focused, maxWidth = _a.maxWidth;
        var attrStr = attr ? attr.name : "";
        if (attr && attr.name) {
            attrStr += ": ";
        }
        var valueStr = values.map(function (item) { return item.name; }).join(" | ");
        var removeable = attr && "removeable" in attr ? attr.removeable : true;
        return (React.createElement("div", { style: {
                display: "inline-block",
                minHeight: 20,
                width: inEditing && !active ? 0 : "auto",
                position: "relative",
                verticalAlign: "inherit",
            } },
            React.createElement(Bubble, { content: active ? t.tagSearchBoxEditingTips : null },
                React.createElement("div", { className: classPrefix + "-tag", ref: function (div) { return (_this["content"] = div); }, style: {
                        display: inEditing ? "none" : undefined,
                        paddingRight: removeable ? undefined : 8,
                    }, onClick: this.handleTagClick },
                    React.createElement(Text, { parent: "span", theme: "label", onClick: function (e) { return _this.handleTagClick(e, "attr"); } }, attrStr),
                    React.createElement("span", { onClick: function (e) { return _this.handleTagClick(e, "value"); } }, valueStr),
                    active && removeable && (React.createElement(Icon, { type: "dismiss", onClick: this.handleDelete })))),
            React.createElement(TagInput, { type: "edit", hidden: !inEditing, maxWidth: maxWidth, handleKeyDown: this.handleKeyDown, active: active, ref: function (input) { return (_this["input-inside"] = input); }, attributes: attributes, dispatchTagEvent: dispatchTagEvent, isFocused: focused === FocusPosType.INPUT_EDIT })));
    };
    return ITag;
}(React.Component));
export var Tag = withConfig(withTranslation(ITag));
//# sourceMappingURL=Tag.js.map